var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryDoubleCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.2,
    height: 12.004,
    viewBox: "0 0 13.2 12.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4604",
    "data-name": "Group 4604",
    transform: "translate(-1423.23 -1288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3572",
    "data-name": "Group 3572",
    transform: "translate(1424 1288)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1218",
    "data-name": "Rectangle 1218",
    width: 12,
    height: 12.004,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2464",
    "data-name": "Group 2464",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    "data-name": "Rectangle 803",
    width: 9.774,
    height: 10.004,
    fill: "none",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M11.225,6,6.257,11.405,4,8.948",
    transform: "translate(-3.71 -3.688)",
    fill: "none",
    stroke: "#058728",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "check-2",
    "data-name": "check",
    d: "M11.527,6.015,6.26,11.4,5.077,10.19",
    transform: "translate(-0.159 -1.684)",
    fill: "none",
    stroke: "#058728",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryDoubleCheckIcon);
export default __webpack_public_path__ + "static/media/history-double-check-icon.c1ae088d1c9d34e86a99621a623ffef5.svg";
export { ForwardRef as ReactComponent };